import type { ComponentType, LazyExoticComponent } from 'react'

import { lazy } from 'react'
import { loaders } from './skin-registry.generated'

type LoaderName = keyof typeof loaders

const cache = new Map<string, LazyExoticComponent<ComponentType<unknown>>>()

/**
 * Resolve a skin `alias` to an Arcana component via lazy dynamic import.
 * Kept on `@setplex/arcana/skin` so importing `get` does not evaluate the
 * full public barrel (`export *` from `exports.ts`).
 */
export function get<P = {}>(name: string): ComponentType<P> | undefined {
  if (!(name in loaders)) return undefined

  let cached = cache.get(name)
  if (!cached) {
    const load = loaders[name as LoaderName]
    cached = lazy(() =>
      load().then((Component) => ({
        default: Component as ComponentType<unknown>,
      }))
    )
    cache.set(name, cached)
  }

  return cached as ComponentType<P>
}
